function setCustomVideoAspectRatio(videoBlock, width, height) {
  const w = Number(width);
  const h = Number(height);
  if (!videoBlock || !w || !h) return;
  videoBlock.style.setProperty('--custom-video-aspect-ratio', w + ' / ' + h);
}

function isCustomVideoMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
}

function getActiveYoutubeIframe(videoBlock) {
  const desktopIframe = videoBlock.querySelector('.custom-video-youtube--desktop');
  const mobileIframe = videoBlock.querySelector('.custom-video-youtube--mobile');

  if (isCustomVideoMobile()) {
    return mobileIframe || desktopIframe;
  }

  return desktopIframe || mobileIframe;
}

function getYoutubeAspectData(videoBlock) {
  const isMobile = isCustomVideoMobile();
  let youtubeId = '';
  let isShort = false;

  if (isMobile && videoBlock.dataset.youtubeIdMobile) {
    youtubeId = videoBlock.dataset.youtubeIdMobile;
    isShort = videoBlock.dataset.youtubeIsShortMobile === 'true';
  } else if (videoBlock.dataset.youtubeIdDesktop) {
    youtubeId = videoBlock.dataset.youtubeIdDesktop;
    isShort = videoBlock.dataset.youtubeIsShortDesktop === 'true';
  } else if (videoBlock.dataset.youtubeIdMobile) {
    youtubeId = videoBlock.dataset.youtubeIdMobile;
    isShort = videoBlock.dataset.youtubeIsShortMobile === 'true';
  }

  return { youtubeId, isShort };
}

async function applyYoutubeAspectRatio(videoBlock) {
  const { youtubeId, isShort } = getYoutubeAspectData(videoBlock);
  if (!youtubeId) return;

  if (isShort) {
    setCustomVideoAspectRatio(videoBlock, 9, 16);
    return;
  }

  try {
    const watchUrl = 'https://www.youtube.com/watch?v=' + youtubeId;
    const response = await fetch(
      'https://www.youtube.com/oembed?url=' + encodeURIComponent(watchUrl) + '&format=json'
    );
    if (!response.ok) throw new Error('YouTube oEmbed request failed');

    const data = await response.json();
    if (data.width && data.height) {
      setCustomVideoAspectRatio(videoBlock, data.width, data.height);
      return;
    }
  } catch (error) {
    console.warn('Custom video: could not load YouTube aspect ratio', error);
  }

  setCustomVideoAspectRatio(videoBlock, 16, 9);
}

function applyUploadedVideoAspectRatio(videoBlock, video) {
  function applyFromMetadata() {
    if (video.videoWidth && video.videoHeight) {
      setCustomVideoAspectRatio(videoBlock, video.videoWidth, video.videoHeight);
    }
  }

  if (video.readyState >= 1) {
    applyFromMetadata();
  } else {
    video.addEventListener('loadedmetadata', applyFromMetadata, { once: true });
  }
}

function applyPosterImageAspectRatio(videoBlock, poster) {
  const img = poster.querySelector('img.custom-video-thumbnail');
  if (!img) return;

  function applyFromImage() {
    if (img.naturalWidth && img.naturalHeight) {
      setCustomVideoAspectRatio(videoBlock, img.naturalWidth, img.naturalHeight);
    }
  }

  if (img.complete) {
    applyFromImage();
  } else {
    img.addEventListener('load', applyFromImage, { once: true });
  }
}

function hideAllYoutubeIframes(videoBlock) {
  videoBlock.querySelectorAll('.custom-video-youtube').forEach(function (iframe) {
    iframe.style.display = 'none';
  });
}

function initCustomVideos(root) {
  const scope = root || document;

  scope.querySelectorAll('.custom-video-inner').forEach(function (videoBlock) {
    if (videoBlock.dataset.customVideoReady === 'true') return;
    videoBlock.dataset.customVideoReady = 'true';

    const poster = videoBlock.querySelector('.custom-video-poster');
    const video = videoBlock.querySelector('video.custom-video');
    const youtubeIframes = videoBlock.querySelectorAll('.custom-video-youtube');
    const hasYoutube = youtubeIframes.length > 0;

    if (hasYoutube) {
      applyYoutubeAspectRatio(videoBlock);
      window.addEventListener('resize', function () {
        applyYoutubeAspectRatio(videoBlock);
      });
    } else if (video) {
      applyUploadedVideoAspectRatio(videoBlock, video);
    } else if (poster) {
      applyPosterImageAspectRatio(videoBlock, poster);
    }

    if (!poster || (!video && !hasYoutube)) return;

    function hidePoster() {
      poster.style.display = 'none';
    }

    function showPoster() {
      poster.style.display = '';
    }

    function playYoutube() {
      const activeIframe = getActiveYoutubeIframe(videoBlock);
      if (!activeIframe) return;

      hideAllYoutubeIframes(videoBlock);
      hidePoster();
      activeIframe.style.display = 'block';

      const baseSrc = activeIframe.dataset.src;
      if (!baseSrc) return;

      if (!activeIframe.src) {
        const joiner = baseSrc.indexOf('?') > -1 ? '&' : '?';
        activeIframe.src = baseSrc + joiner + 'autoplay=1';
      }
    }

    function playUploadedVideo() {
      hidePoster();
      video.style.display = 'block';

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          showPoster();
          video.style.display = '';
        });
      }
    }

    poster.addEventListener('click', function () {
      if (hasYoutube) {
        playYoutube();
        return;
      }

      if (video) {
        playUploadedVideo();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initCustomVideos(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initCustomVideos(event.target);
});
